var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E4EEFB",
    width: 60,
    height: 60,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.112 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3v22a3 3 0 0 0 3 3h29.084a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3z",
    fill: "#3979FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FCBFF",
    cx: 34.275,
    cy: 20.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.275 13c.274 0 .544.015.81.043V25a3.001 3.001 0 0 1-2.154 2.879A7.5 7.5 0 0 1 34.275 13z",
    fill: "#0A41F3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.547 15.847 1.51-.838a1 1 0 0 1 .97 0l1.51.838a1 1 0 0 0 1.476-1.015l-.268-1.871a1 1 0 0 1 .308-.873l1.22-1.139a1 1 0 0 0-.54-1.721l-1.781-.254a1 1 0 0 1-.762-.562l-.744-1.57a1 1 0 0 0-1.808 0l-.743 1.57a1 1 0 0 1-.763.562l-1.78.254a1 1 0 0 0-.541 1.721l1.22 1.14a1 1 0 0 1 .308.872l-.267 1.87a1 1 0 0 0 1.475 1.016zm-4.681 4.556H24.05a1.25 1.25 0 0 1 0 2.5H10.866a1.25 1.25 0 1 1 0-2.5z",
    fill: "#FFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.55f25f89779dc7b569adad317d0017fd.svg";
export { ForwardRef as ReactComponent };